import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, submissionViewModel) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();

    ctrl.init = function () {
        $scope.accountHolder = submissionVM.baseData.accountHolder.value;
        $scope.accountHolder.primaryPhoneType = null;
        submissionVM.baseData.policyAddress.addressType.value = submissionVM.baseData.policyAddress.addressType.value || 'home';

        $scope.submissionVM = submissionVM;

        $scope.postalCodeReadonly = angular.isDefined($scope.submissionVM.baseData.policyAddress.postalCode.value);
        $scope.stateReadonly = angular.isDefined($scope.submissionVM.baseData.policyAddress.state.value);

        var today = new Date();
        today.setHours(0, 0, 0, 0);
        $scope.today = {
            year: today.getFullYear(),
            month: today.getMonth(),
            day: today.getDate()
        };
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'submissionViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/controllers/HOContactDetailsCtrl.js
// module id = 2148
// module chunks = 0